import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.075 1C4.685-.333 2.432-.333 1.042 1a3.32 3.32 0 0 0 0 4.83l4.376 4.2-4.314 4.14a3.32 3.32 0 0 0 0 4.83c1.39 1.333 3.642 1.333 5.032 0l6.822-6.547a3.315 3.315 0 0 0 .28-4.527 3.5 3.5 0 0 0-.342-.38z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }